import cacheService from '../../../services/cacheService';
import { clearSessionUserCache, getSessionUser } from '../api/getSessionUser';
import { User } from '../domain/User';
import { clearStoredUser } from './userStorage';

export function refreshSessionUser(): Promise<User | undefined> {
  clearSessionUserCache();
  clearStoredUser();
  cacheService.removeAll();

  return getSessionUser();
}
